<template>
  <div class="industry">
    <Menu></Menu>
    <Tabber
      :tabberData="tabberData"
      :activeIndex="activeIndex"
      :tabTitle="tabTitle"
      @changeTabber="changeTabber"
    >
      <div slot="tabberContent" class="box" >
        <div>
           <img src="../../styles/images/ysy/yj1.png" alt="">
        </div>
         <div>
           <img src="../../styles/images/ysy/yj2.png" alt="">
        </div>
         <div>
           <img src="../../styles/images/ysy/yj3.png" alt="">
        </div>
      </div>
    </Tabber>
  </div>
</template>
<script>
import { getBusinessList, getIndustry } from "@/api/manage";
import Menu from "../../components/menu/menu.vue";
import Tabber from "../../components/menu/tabber.vue";
export default {
  components: { Menu, Tabber },
  data() {
    return {
      tabberData: [
        { id: "1", name: "硬件支撑" }
      ],
      activeIndex: "1",
      tabTitle: "硬件支撑",
      listData: {},
      infoData: [],
    };
  },
  watch: {
    $route(to, from) {
      this.activeIndex = to.params.id;
      this.setInfo(this.activeIndex);
      window.scrollTo(0, 0);
    },
  },
  mounted() {
    window.scrollTo(0, 0);
    // this.getList();
    // this.activeIndex = this.$route.params.id;
  },
  methods: {
 
    async changeTabber(index) {
      console.log(index);
    },
  }
};
</script>
<style scoped>
.title {
  font-size: 20px;
  color: #333;
  text-align: center;
}
.sketchTitle,
.featureTitle {
  font-size: 18px;
  color: #666;
  padding-bottom: 10px;
  font-weight: bold;
}
.sketchContent,
.feature p {
  font-size: 14px;
  color: #666;
  line-height: 28px;
  margin-bottom: 0;
}
.sketchContent {
  text-indent: 2em;
}
.sketchImg {
  margin: 60px 0;
  text-align: center;
}
.sketchImg img {
  height: auto;
  width: auto;
  max-width: 1100px;
}
.box {
  width: 1200px;
  margin: 0 auto;
  
}
.box img {
  width: 100%;
  height: 100%;

}
</style>